import HeaderComponent from "./HeaderComponent";
import TextEditorComponent from "./TextEditorComponent";

const EditorComponent = () => {
  return (
    <>
      <HeaderComponent/>
      <TextEditorComponent />
    </>
  );
}

export default EditorComponent